import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import i from "../utils.js";
import S from "../helpers/parseHeaders.js";
var h = Symbol("internals");
function l(r) {
  return r && String(r).trim().toLowerCase();
}
function p(r) {
  return r === !1 || r == null ? r : i.isArray(r) ? r.map(p) : String(r);
}
function d(r) {
  var t = /* @__PURE__ */Object.create(null),
    n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  var s;
  for (; s = n.exec(r);) t[s[1]] = s[2];
  return t;
}
var A = function A(r) {
  return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(r.trim());
};
function g(r, t, n, s, e) {
  if (i.isFunction(s)) return s.call(this, t, n);
  if (e && (t = n), !!i.isString(t)) {
    if (i.isString(s)) return t.indexOf(s) !== -1;
    if (i.isRegExp(s)) return s.test(t);
  }
}
function E(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function (t, n, s) {
    return n.toUpperCase() + s;
  });
}
function H(r, t) {
  var n = i.toCamelCase(" " + t);
  ["get", "set", "has"].forEach(function (s) {
    Object.defineProperty(r, s + n, {
      value: function value(e, o, f) {
        return this[s].call(this, t, e, o, f);
      },
      configurable: !0
    });
  });
}
var b = /*#__PURE__*/function () {
  function b(t) {
    _classCallCheck(this, b);
    t && this.set(t);
  }
  return _createClass(b, [{
    key: "set",
    value: function set(t, n, s) {
      var e = this;
      function o(c, u, a) {
        var y = l(u);
        if (!y) throw new Error("header name must be a non-empty string");
        var m = i.findKey(e, y);
        (!m || e[m] === void 0 || a === !0 || a === void 0 && e[m] !== !1) && (e[m || u] = p(c));
      }
      var f = function f(c, u) {
        return i.forEach(c, function (a, y) {
          return o(a, y, u);
        });
      };
      if (i.isPlainObject(t) || t instanceof this.constructor) f(t, n);else if (i.isString(t) && (t = t.trim()) && !A(t)) f(S(t), n);else if (i.isHeaders(t)) {
        var _iterator = _createForOfIteratorHelper(t.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              c = _step$value[0],
              u = _step$value[1];
            o(u, c, s);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else t != null && o(n, t, s);
      return this;
    }
  }, {
    key: "get",
    value: function get(t, n) {
      if (t = l(t), t) {
        var s = i.findKey(this, t);
        if (s) {
          var e = this[s];
          if (!n) return e;
          if (n === !0) return d(e);
          if (i.isFunction(n)) return n.call(this, e, s);
          if (i.isRegExp(n)) return n.exec(e);
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
  }, {
    key: "has",
    value: function has(t, n) {
      if (t = l(t), t) {
        var s = i.findKey(this, t);
        return !!(s && this[s] !== void 0 && (!n || g(this, this[s], s, n)));
      }
      return !1;
    }
  }, {
    key: "delete",
    value: function _delete(t, n) {
      var s = this;
      var e = !1;
      function o(f) {
        if (f = l(f), f) {
          var c = i.findKey(s, f);
          c && (!n || g(s, s[c], c, n)) && (delete s[c], e = !0);
        }
      }
      return i.isArray(t) ? t.forEach(o) : o(t), e;
    }
  }, {
    key: "clear",
    value: function clear(t) {
      var n = Object.keys(this);
      var s = n.length,
        e = !1;
      for (; s--;) {
        var o = n[s];
        (!t || g(this, this[o], o, t, !0)) && (delete this[o], e = !0);
      }
      return e;
    }
  }, {
    key: "normalize",
    value: function normalize(t) {
      var n = this,
        s = {};
      return i.forEach(this, function (e, o) {
        var f = i.findKey(s, o);
        if (f) {
          n[f] = p(e), delete n[o];
          return;
        }
        var c = t ? E(o) : String(o).trim();
        c !== o && delete n[o], n[c] = p(e), s[c] = !0;
      }), this;
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this$constructor;
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }
      return (_this$constructor = this.constructor).concat.apply(_this$constructor, [this].concat(t));
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var n = /* @__PURE__ */Object.create(null);
      return i.forEach(this, function (s, e) {
        s != null && s !== !1 && (n[e] = t && i.isArray(s) ? s.join(", ") : s);
      }), n;
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
  }, {
    key: "toString",
    value: function toString() {
      return Object.entries(this.toJSON()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          t = _ref2[0],
          n = _ref2[1];
        return t + ": " + n;
      }).join("\n");
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "AxiosHeaders";
    }
  }], [{
    key: "from",
    value: function from(t) {
      return t instanceof this ? t : new this(t);
    }
  }, {
    key: "concat",
    value: function concat(t) {
      var s = new this(t);
      for (var _len2 = arguments.length, n = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        n[_key2 - 1] = arguments[_key2];
      }
      return n.forEach(function (e) {
        return s.set(e);
      }), s;
    }
  }, {
    key: "accessor",
    value: function accessor(t) {
      var s = (this[h] = this[h] = {
          accessors: {}
        }).accessors,
        e = this.prototype;
      function o(f) {
        var c = l(f);
        s[c] || (H(e, f), s[c] = !0);
      }
      return i.isArray(t) ? t.forEach(o) : o(t), this;
    }
  }]);
}();
b.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
i.reduceDescriptors(b.prototype, function (_ref3, t) {
  var r = _ref3.value;
  var n = t[0].toUpperCase() + t.slice(1);
  return {
    get: function get() {
      return r;
    },
    set: function set(s) {
      this[n] = s;
    }
  };
});
i.freezeMethods(b);
export { b as default };
